import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <div className="text-sm text-gray-600">
            © {currentYear} ivoliq.io
          </div>

          {/* Links */}
          <div className="flex gap-6 text-sm">
            <Link 
              to="/impressum" 
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              {t('footer.impressum', 'Impressum')}
            </Link>
            <Link 
              to="/privacy" 
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              {t('footer.privacy', 'Datenschutz')}
            </Link>
            <Link 
              to="/terms" 
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              {t('footer.terms', 'AGB')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
